import React, { useState, createContext } from 'react';

export const MenuContext = createContext();

export default function MenuProvider({ children }) {

  const [open, setOpen] = useState();

  return (
    <MenuContext.Provider value={{ open, setOpen }}>
      {children}
    </MenuContext.Provider>
  );
}
